import { useEffect } from 'react';
import { useAnimatedRouteContext } from './AnimatedRoute';
const useAnimatedImage = (productId, el, productUuid) => {
    const { registerAnimatedImage, unregisterAnimatedImage } = useAnimatedRouteContext();
    useEffect(() => {
        if ((productId || productUuid) && el.current) {
            registerAnimatedImage({
                el,
                productId,
                productUuid,
            });
        }
        return () => {
            if (productId || productUuid) {
                unregisterAnimatedImage(productId, productUuid);
            }
        };
    }, [productId, productUuid]);
};
export default useAnimatedImage;
